import React, { useEffect } from 'react';

function AINotetakerSignup() {
  useEffect(() => {
    // Load the form embed script
    const script = document.createElement('script');
    script.src = 'https://api.strategysparks.com/js/form_embed.js';
    script.async = true;
    script.onerror = () => {
      // Silently handle script loading errors to prevent page crashes
      // Errors are handled globally in index.js
    };
    document.body.appendChild(script);

    return () => {
      // Cleanup: remove script when component unmounts
      const existingScript = document.querySelector('script[src="https://api.strategysparks.com/js/form_embed.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <section className="section ai-notetaker-signup" id="ai-notetaker-signup" aria-label="AI Notetaker Signup">
      <div className="container">
        <h2 className="h2 section-title">Get Early Access</h2>

        <p className="section-text">Experience the future of note-taking.</p>
      </div>

      <div style={{ width: '100%', marginBlockStart: '30px', paddingInline: '0px', boxSizing: 'border-box' }}>
        <iframe src="https://api.strategysparks.com/widget/form/GDDMKaidOdufu7TaBZmO" style={{ width: '100%', minHeight: '200px', border: 'none', borderRadius: '3px', display: 'block' }} id="inline-GDDMKaidOdufu7TaBZmO" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="Email Form" data-height="460" data-layout-iframe-id="inline-GDDMKaidOdufu7TaBZmO" data-form-id="GDDMKaidOdufu7TaBZmO" title="Email Form" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </section>
  );
}

export default AINotetakerSignup;
